
<h3 mat-card-subtitle>Errors</h3>
<mat-list role="list">
  @for (error of errors; track error) {
    <mat-list-item role="listitem">
      <mat-icon class="me-2">error</mat-icon> {{error}}
    </mat-list-item>
  }
</mat-list>